import dayjs from 'dayjs';
import {useMemo} from 'react';

import type {_Object} from '../Paramut';
import {useRoot} from '../Root';
import type {Millisecond} from '../Time';

export type ProgressVariables<Mut extends boolean = false> = _Object<
  {
    daysReached?: number;
    day: number;
    month: number;
  },
  Mut
>;

export default function useProgressVariables(
  now: Millisecond,
): ProgressVariables {
  const {profileStorage} = useRoot();

  const $target = dayjs(now).startOf('day');

  const {start: startDate} = profileStorage.current ?? {};
  const $start = startDate
    ? dayjs(new Date(startDate.year, startDate.month, startDate.day)).startOf(
        'day',
      )
    : undefined;

  const daysReached = $start
    ? stubNegativeValues($target.diff($start, 'days', false))
    : undefined;
  const day = $target.date();
  const month = $target.month();

  return useMemo(
    () => ({
      daysReached,
      day,
      month,
    }),
    [daysReached, day, month],
  );
}

function stubNegativeValues(_: number): number | undefined {
  if (_ < 0) {
    return undefined;
  }
  return _;
}
